import PropTypes from 'prop-types';
import { Component } from 'react';

import { isDev } from 'lib/utils';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
    this.logPrefix = '[promobit-error-boundary]';
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  _logError(message) {
    if (isDev()) {
      // eslint-disable-next-line no-console
      console.log(`${this.logPrefix} ${message}`);
    }
  }

  async componentDidCatch(error, info) {
    this._logError(`ErrorBoundary caught error: ${error.message}`);
    this._logError(`Component stack: ${info.componentStack}`);

    if (!isDev()) {
      const { captureException } = await import('@sentry/nextjs');
      captureException(error, { contexts: { react: info.componentStack } });
    }
  }

  render() {
    const { fallback: Fallback, children } = this.props;

    if (this.state.hasError) {
      if (!Fallback) {
        return null;
      }

      if (typeof Fallback === 'function') {
        return <Fallback />;
      }

      return Fallback;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
};

export default ErrorBoundary;
